export default __webpack_public_path__ + "static/Ymo-6a29bc744daf5ea4e09ed6436f9dbd01.png";